import { nightMobOf } from '../data/night-mobs.js';
/** Struck this recently, a creature is still in its fight: it does not leave mid-blow. */
export const SHIFT_CALM_MS = 10_000;
/**
 * A creature off its shift leaves out of every player's sight; after this
 * long it leaves anyway, so a player camping a den still sees the night fall.
 */
export const SHIFT_LINGER_MS = 60_000;
/** The night creature that takes this den at night, or undefined for a den that keeps its creatures. */
export function nightDen(biome, mob, 
/** Its place among that kind's dens in that biome, from 0. */
rank) {
    if (biome === undefined || rank % 2 !== 0)
        return undefined;
    return nightMobOf(biome, mob);
}
/** Whether a creature of this shift is out at this hour. */
export function onShift(shift, night) {
    return shift === (night ? 'night' : 'day');
}
/**
 * Whether a creature off its shift leaves now: never in a fight (after a
 * player, backing away, or struck within `SHIFT_CALM_MS`), and out of sight
 * until `SHIFT_LINGER_MS` past the change.
 */
export function leavesShift(creature, changedAt, now) {
    if (creature.fighting)
        return false;
    if (creature.lastHurtAt !== null && now < creature.lastHurtAt + SHIFT_CALM_MS)
        return false;
    return !creature.seen || now >= changedAt + SHIFT_LINGER_MS;
}
//# sourceMappingURL=night-shift.js.map